import configureAppStore from './configureStore';
import { claimTabSession } from '../utils/tabSession';

// Must run before the store is built
claimTabSession();

const { store, persistor } = configureAppStore();

export { store, persistor };
